<template>
  <div class="chats">
    <div
        v-if="busy !== true"
      v-for="(msgGrp, index) in formattedChatData"
      :key="msgGrp.senderId+String(index)"
      class="chat"
      :class="{'chat-left': msgGrp.senderId !== myId, 'chat-other-user': msgGrp.senderId !== myId && !msgGrp.isClientSide}"
    >
      <div class="chat-avatar">
        <b-avatar
            v-if="msgGrp.senderId !== myId ? getAvatar(msgGrp.senderId) : profileUserAvatar"
            size="36"
            class="avatar-border-2 box-shadow-1"
            variant="transparent"
            :src="require(`@/assets/images/avatars/${msgGrp.senderId !== myId ? getAvatar(msgGrp.senderId) : profileUserAvatar}-small.png`)"
        />
      </div>
      <div class="chat-body">
        <div v-for="msgData in msgGrp.messages" :key="msgData.time" class="chat-content">
          <p>{{ msgData.msg }}</p>
        </div>
      </div>
    </div>
    <div v-if="loading || busy" class="text-center">
      <b-spinner label="Loading..." />
    </div>
  </div>
</template>

<script>

import { mapActions, mapGetters, mapMutations } from 'vuex'

export default {
  data() {
    return {
      loading: false,
      chatData: null,
      intervalGetChatDataId: null,
    }
  },
  props: {
    session: {
      type: Object,
      required: true,
    },
    profileUserAvatar: {
      type: String,
      required: true,
    },
    noAvatar: {
      type: Boolean,
      default: false,
    },
    busy:{
      type: Boolean,
      default: false,
    }
  },
  watch:{
    session:{
      handler(){
        this.refreshChat()
      },
      immediate:true,
    },
  },
  created() {
    let $this = this
    this.refreshChat()
    this.intervalGetChatDataId = setInterval(() => $this.fetchChatMessages(), 10*1000); // Fetch messages every 10 seconds
    this.$root.$on("system::notification::CHAT",this.onNewMessage)
  },
  beforeDestroy() {
    clearInterval(this.intervalGetChatDataId);
    this.$root.$off("system::notification::CHAT",this.onNewMessage)
  },
  computed:{
    ...mapGetters("user",["myId"]),
    ...mapGetters("chat",["chatBySessionId"]),

    formattedChatData() {
      if (!this.chatData || !this.chatData.messages) return []
      let $this = this

      let chatLog = chatLog = $this.chatData.messages || []

      const formattedChatLog = []
      let chatMessageSenderId = chatLog[0] ? chatLog[0].senderId : undefined
      let msgGroup = {
        sender: chatMessageSenderId,
        isClientSide: chatLog[0] ? chatLog[0].isClientSide : undefined,
        messages: [],
      }

      chatLog.forEach((msg, index) => {
        if (chatMessageSenderId === msg.senderId) {
          msgGroup.messages.push({
            msg: msg.content,
            time: msg.time,
          })
        } else {
          chatMessageSenderId = msg.senderId
          formattedChatLog.push(msgGroup)
          msgGroup = {
            senderId: msg.senderId,
            isClientSide: msg.isClientSide,
            messages: [{
              msg: msg.content,
              time: msg.time,
            }],
          }
        }
        if (index === chatLog.length - 1) formattedChatLog.push(msgGroup)
      })

      return formattedChatLog
    },
  },
  methods:{
    ...mapActions("chat", ["getChatMessages", "setMessagesRead"]),
    ...mapMutations("chat", ["updateChat"]),
    onNewMessage(payload){
      if(payload?.params?.sessionId === this.session.id){
        console.log("ChatLog onNewMessage refreshChat", payload)
        this.refreshChat();
        this.updateChat([payload.params.message]);
      }else {
        console.log("ChatLog onNewMessage ignored", payload)
      }
    },
    refreshChat(){
      if(this.session == null || this.session.id == null){
        return;
      }
      this.getChatData();
      this.loading = true
      this.fetchChatMessages();
    },
    fetchChatMessages(){
      let $this = this
      this.getChatMessages({ sessionId: this.session.id }).then(() => {
        $this.getChatData();
        if($this.loading){
          setTimeout(() => $this.$emit('loaded', $this.session.id), 500)
        }
        $this.loading = false;
      });
    },
    getChatData(){
      let $this = this
      this.chatData = this.chatBySessionId(this.session.id)
      this.setMessagesRead({ sessionId: $this.session.id });
    },
    getAvatar(){
      return null;
    },
  }
}
</script>

<style>

</style>
